import { Heading, Box, Stack, Link as ChakraLink, Flex, IconButton } from '@chakra-ui/react';
import { HiMenu } from 'react-icons/hi';
import { Link, useLocation } from 'react-router-dom';
import { useMenu } from '@/hooks/use-menu.tsx';
import { useSidebar } from '@/hooks/use-sidebar.tsx';

export default function Header() {
  const { onToggle } = useMenu();
  const { onToggle: onToggleSidebar } = useSidebar();
  const location = useLocation();
  const isMapView = location.pathname.startsWith('/map');
  const headerHeight = isMapView ? '84px' : '48px';

  return (
    <Box
      as='header'
      w='full'
      h={headerHeight}
      position='relative'
      top='0'
      left='0'
      zIndex={10}
    >
      {/* Main header bar */}
      <Box bg='#2f4050' h='48px' px='4'>
        <Stack direction='row' align='center' w='full' h='full'>
          <Flex
            align='center'
            gap='4'
            w='full'
            justify='space-between'
            display={{ base: 'flex', lg: 'none' }}
          >
            <Heading as='h2' size='md' letterSpacing='tight' my='4' color='gray.100'>
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='/'>Saskatchewan Soil Information System</Link>
              </ChakraLink>
            </Heading>
            <IconButton
              display={{ base: 'flex', lg: 'none' }}
              variant='ghost'
              color='gray.100'
              aria-label='Open menu'
              onClick={onToggle}
              size='sm'
            >
              <HiMenu />
            </IconButton>
          </Flex>
          <Flex gap='8' justify='space-between' w='full' display={{ base: 'none', lg: 'flex' }}>
            <Flex align='center' gap='4'>
              <IconButton
                variant='ghost'
                aria-label='Toggle sidebar'
                size='sm'
                _hover={{ bg: '#2f4050' }}
                onClick={onToggleSidebar}
              >
                <HiMenu color='white' />
              </IconButton>
              <Heading as='h2' size='md' letterSpacing='tight' my='4' color='gray.100'>
                <ChakraLink fontSize='sm' color='gray.100' asChild>
                  <Link to='/'>Saskatchewan Soil Information System</Link>
                </ChakraLink>
              </Heading>
            </Flex>
            <Stack
              marginEnd='auto'
              direction='row'
              align='center'
              gap='6'
              display={{ base: 'none', lg: 'flex' }}
            >
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='/map'>Map</Link>
              </ChakraLink>
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='https://mapper.sksis.ca/users/sign_in' target='_blank'>
                  SKSIS Mapper
                </Link>
              </ChakraLink>
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='/data-download'>Data Download</Link>
              </ChakraLink>
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='/documentation'>Documentation</Link>
              </ChakraLink>
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='/cpssl'>CPSSL</Link>
              </ChakraLink>
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='/contact'>Contact</Link>
              </ChakraLink>
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='/acknowledgments'>Acknowledgments</Link>
              </ChakraLink>
              <ChakraLink fontSize='sm' color='gray.100' asChild>
                <Link to='/citation'>Citation</Link>
              </ChakraLink>
            </Stack>
          </Flex>
        </Stack>
      </Box>

      {/* Full-width teal strip (map view only) */}
      {isMapView && (
        <Flex w='full' h='36px'>
          <Box
            w='full'
            bg='teal.500'
            px='4'
            display='flex'
            alignItems='center'
            justifyContent='flex-end'
          >
            <ChakraLink
              color='white'
              fontSize='md'
              fontWeight='semibold'
              _hover={{ color: 'white', textDecoration: 'underline' }}
              asChild
            >
              <a href='https://app.sksis.ca' target='_blank' rel='noreferrer'>
                Previous Version
              </a>
            </ChakraLink>
          </Box>
        </Flex>
      )}
    </Box>
  );
}
